import { Action, createReducer, on } from '@ngrx/store';
import { DeviceSubscriptionOfferExt } from 'src/app/generated/CrossPoint.License.Server';
import { LOCAL_STORAGE_SHOPPING_BASKET_KEY } from 'src/app/utils/constants/licenses.consts';
import { ILicensesState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import {
  addLicenseToShoppingBasketSuccessAction, 
  clearShoppingBasketSuccessAction, 
  getActiveLicensesInfoSuccessAction,
  getAuthInfoLicensesFailedAction, 
  getAuthInfoLicensesSuccessAction, 
  getExpiredLicensesInfoSuccessAction, 
  getExpiringLicensesInfoSuccessAction,
  getOrdersFailedAction, 
  getOrdersSuccessAction, 
  getOrderFailedAction, 
  getOrderSuccessAction,
  removeLicenseFromShoppingBasketSuccessAction, 
  updateLicensesShoppingBasketSuccessAction, 
  getSubscriptionSuccessAction, 
  getSubscriptionFailedAction,
  getLicensesDetailsInfoSuccessAction,
  getLicensesDetailsInfoFailedAction,
  getInsightsOffersSuccessAction,
  getInsightsOffersFailedAction, 
} from '../actions/licenses.actions'

const initialState: ILicensesState = {
  orders: null,
  activeStoreLicensesInfo: null,
  expiredStoreLicensesInfo: null,
  expiringStoreLicensesInfo: null,
  insightsOffers: null,
  shoppingBasket: null,
  permission: null,
  annotatedOrder: null,
  manualSubscription: null,
  subscriptionDetails: null
};

export const licensesReducerImplicit = createReducer(
  initialState,
  on(getLicensesDetailsInfoSuccessAction, (state, { data: licensesDetails }) => ({
    ...state,
    subscriptionDetails: licensesDetails,
  })),
  on(getLicensesDetailsInfoFailedAction, (state) => ({
    ...state,
    subscriptionDetails: null,
  })),
  on(getInsightsOffersSuccessAction, (state, { data: offers }) => ({
    ...state,
    insightsOffers: offers,
  })),
  on(getInsightsOffersFailedAction, (state) => ({
    ...state,
    insightsOffers: null,
  })),
  on(addLicenseToShoppingBasketSuccessAction, (state, { data: offer }) => {
    const newShoppingBasket: DeviceSubscriptionOfferExt[] = (state.shoppingBasket) ? [...state.shoppingBasket, offer] : [offer];
    const shoppingBasket = filterDuplicates(newShoppingBasket);
    
    updateLocalStorage(shoppingBasket);
    return { ...state, shoppingBasket };
  }),
  on(clearShoppingBasketSuccessAction, (state) => {
    const emptyShoppingBasket: DeviceSubscriptionOfferExt[] = [];
    
    updateLocalStorage(emptyShoppingBasket);
    return { ...state, shoppingBasket: emptyShoppingBasket };
  }),
  on(getActiveLicensesInfoSuccessAction, (state, { data: activeStoreLicensesInfo }) => ({
    ...state,
    activeStoreLicensesInfo,
  })),
  on(getExpiringLicensesInfoSuccessAction, (state, { data: expiringStoreLicensesInfo }) => ({
    ...state,
    expiringStoreLicensesInfo,
  })),
  on(getExpiredLicensesInfoSuccessAction, (state, { data: expiredStoreLicensesInfo }) => ({
    ...state,
    expiredStoreLicensesInfo,
  })),
  on(removeLicenseFromShoppingBasketSuccessAction, (state, { data: offer }) => {
    const shoppingBasket: DeviceSubscriptionOfferExt[] = state.shoppingBasket?.filter((o: DeviceSubscriptionOfferExt) => o.serial !== offer.serial);

    updateLocalStorage(shoppingBasket);
    return { ...state, shoppingBasket };
  }),
  on(updateLicensesShoppingBasketSuccessAction, (state, { data: updatedShoppingBasket }) => {
    const shoppingBasket: DeviceSubscriptionOfferExt[] = filterDuplicates(updatedShoppingBasket);

    updateLocalStorage(shoppingBasket);
    return { ...state, shoppingBasket };
  }),   
  on(getOrdersSuccessAction, (state, {data: orderLicenses}) => ({
    ...state,
    orders: orderLicenses,
  })),
  on(getOrdersFailedAction, (state,) => ({
    ...state,
    orders: null,
  })),
  on(getOrderSuccessAction, (state, {data: orderLicense}) => ({
    ...state,
    annotatedOrder: orderLicense,
  })),
  on(getOrderFailedAction, (state,) => ({
    ...state,
    annotatedOrder: null,
  })),
  on(getSubscriptionSuccessAction, (state, {data: manualSubscription}) => ({
    ...state,
    manualSubscription: manualSubscription,
  })),
  on(getSubscriptionFailedAction, (state,) => ({
    ...state,
    manualSubscription: null,
  })),
  on(getAuthInfoLicensesSuccessAction, (state, {data: permission}) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoLicensesFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
);

function updateLocalStorage(shoppingBasket: DeviceSubscriptionOfferExt[]): void {
  const jsonShoppingBasket: string = JSON.stringify(shoppingBasket);
  localStorage.setItem(LOCAL_STORAGE_SHOPPING_BASKET_KEY, jsonShoppingBasket);
}

function filterDuplicates(shoppingBasket: DeviceSubscriptionOfferExt[]): DeviceSubscriptionOfferExt[] {
  let uniques: DeviceSubscriptionOfferExt[] = [];

  shoppingBasket.forEach((offer: DeviceSubscriptionOfferExt,) => { 
    const isUnique: boolean = uniques.some((o: DeviceSubscriptionOfferExt) => o.serial === offer.serial) === false;
    if (isUnique) {
      uniques = [...uniques, offer];
    }
  });

  return uniques;
}

export function licensesReducer(state: any, action: Action): ILicensesState {
  return licensesReducerImplicit(state, action);
}
